export enum damageStatuses {
  open = 'Offen',
  closed = 'Geschlossen',
}
